<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">CONTENTS</p>
<p class="toc"><a href="#/Acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/Introduction">Introduction: California Dreamin’</a></p>
<p class="toc1"><a href="#/Part1#P1">P<span class="small">ART</span> I: C<span class="small">URSED</span> H<span class="small">OLLYWOOD</span></a></p>
<p class="toc"><a href="#/Chapter1#C1">1. Curse of the Best Actress Award</a></p>
<p class="toc"><a href="#/Chapter2#C2">2. The Curse of <i>The Exorcist</i></a></p>
<p class="toc"><span href="#/Chapter3#C3" title="Link target outside of Sample">3. The Curse of <i>The Crow</i></span></p>
<p class="toc"><span href="#/Chapter4#C4" title="Link target outside of Sample">4. The Most Cursed Film in Hollywood</span></p>
<p class="toc1"><span href="#/Part2#P2" title="Link target outside of Sample">P<span class="small">ART</span> II: P<span class="small">ROPHECIES AND</span> P<span class="small">REMONITIONS</span></span></p>
<p class="toc"><span href="#/Chapter5#C5" title="Link target outside of Sample">5. James Dean: A Race to the Death</span></p>
<p class="toc"><span href="#/Chapter6#C6" title="Link target outside of Sample">6. Oliver Reed: A Drink to Die For</span></p>
<p class="toc"><span href="#/Chapter7#C7" title="Link target outside of Sample">7. Sharon Tate, Jay Sebring, Premonitions and Murder</span></p>
<p class="toc"><span href="#/Chapter8#C8" title="Link target outside of Sample">8. Carrie Fisher and the Force</span></p>
<p class="toc"><span href="#/Chapter9#C9" title="Link target outside of Sample">9. John Lennon and the Number 9</span></p>
<p class="toc"><span href="#/Chapter10#C10" title="Link target outside of Sample">10. Prince, Tupac and Naya Rivera</span></p>
<p class="toc1"><span href="#/Part3#P3" title="Link target outside of Sample">P<span class="small">ART</span> III: G<span class="small">HOSTS AND</span> L<span class="small">EGENDS</span></span></p>
<p class="toc"><span href="#/Chapter11#C11" title="Link target outside of Sample">11. Rudolph Valentino and Falcon Lair</span></p>
<p class="toc"><span href="#/Chapter12#C12" title="Link target outside of Sample">12. The Strange Death and Curse of the Hot Toddy</span></p>
<p class="toc"><span href="#/Chapter13#C13" title="Link target outside of Sample">13. The Mystery of the Houdini Estate</span></p>
<p class="toc"><span href="#/Chapter14#C14" title="Link target outside of Sample">14. The Medieval Torture Museum</span></p>
<p class="toc"><span href="#/Chapter15#C15" title="Link target outside of Sample">15. El Coyote Café</span></p>
<p class="toc"><span href="#/Chapter16#C16" title="Link target outside of Sample">16. The Sad Spirit of Ramon Novarro</span></p>
<p class="toc"><span href="#/Chapter17#C17" title="Link target outside of Sample">17. The Escape Hotel</span></p>
<p class="toc"><span href="#/Chapter18#C18" title="Link target outside of Sample">18. The Mansion</span></p>
<p class="toc1"><span href="#/Epilogue" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?007b95ec